import ThemeToggle from '../theme_toggle';
import { Drafts } from '../calligraff/editor/drafts.js';

new ThemeToggle();
Drafts.clearOtherUsers(document.body?.dataset.currentUser || '').catch(() => {});
